
const objContext = JSON.parse(sessionStorage.getItem("context"));
if(objContext == null || objContext.store_name == null)
    location.href='index.html';
var id_current_store = null, url_picture = null, objStoreInfo = null;

const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab'),
    selectMenu = document.querySelector("#selectMenuRecommended"),
    selectCategories = document.querySelector("#selectCategoryRecommended"),
    selectProduct = document.querySelector("#selectProductRecommended"),
    selectCategoriesCard = document.querySelector("#selectCategoryCard"),
    selectProductCard = document.querySelector("#selectProductCard"),


    btnAddRecommendedProduct = document.querySelector('.btn-add-reccomended-product'),
    btnSaveRecommendadedProduct = document.querySelector('#btn-save-product-recommended'),
    btnCancelAddProduct = document.querySelector('#cancelAddProduct'),
    btnUpdateProduct = document.querySelector('#btn-save-recommended'),
    containerRecommendedAdded = document.querySelector('.recommended-added-container'),
    panelAddProduct = document.querySelector('#panelAddProduct'),
    panelListProduct = document.querySelector('#panelListProduct'),
    labelRecomended = document.querySelector('#LabelRecommended');

//sorteable
let containerTodragAndDrop = document.querySelector('#panelListProduct');
let sortable = new Sortable(containerTodragAndDrop, {
    animation: 150,
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
});


let productToAdd = null,
    arrayRecommendedProducts = [];


if(sectionTab != null)
    sectionTab[6].classList.add('sidebar-menu-container-section-tab--active');


document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

window.addEventListener("load", loadPage);

function loadPage(){
    id_current_store = localStorage.getItem("currentStore");
    labelRecomended.textContent = '';

    if(id_current_store == null || objContext == null)
        location.href='index.html';
    else {
        document.querySelector('.sidebar-profile-img img').src = objContext.store_image
        document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')

        loadSelectMenus();
    }
}

/******************** GET DATA MENÚS ***************************/
var menuData = null;

function loadSelectMenus(){
    UI.showLoader();

    fetch(
        BASE_URLS.Dinny.api + `/stores/${id_current_store}?req_id=${new Date().getTime()}`,
        {
          credentials: 'include'
        }
    ).then(function(response){
        if(response.ok){
            UI.hideLoader();
            selectMenu.innerHTML = '<option value="0" hidden="" selected="">Selecciona un menú</option>';

            response.json().then(function(json){
                objStoreInfo = json;

                if(objStoreInfo.menu && objStoreInfo.menu != null && objStoreInfo.menu.length > 0){
                    objStoreInfo.menu.forEach((element) => {
                        selectMenu.insertAdjacentHTML(
                            'beforeend',
                            `<option value='${element.id}'>${element.name}</option>`
                        )
                    });
                }else{
                    UI.message({ title: 'No tienes menús en tu establecimiento', content: 'Para poder crear etiquetas es necesario que el establecimiento cuente al menos un menú sincronizado con Dinny.<br/><br/>Por favor, crea un menú en tu administrador y sincronízalo con Dinny para que puedas agregar etiquetas a los productos.', accept: 'Aceptar' }, function(){
                        location.href='index.html';
                    });
                    return;
                }

                let idMenu = sessionStorage.getItem('idmenu');
                if(idMenu != null && idMenu.length > 0){
                    selectMenu.value = idMenu;
                    selectMenu.dispatchEvent(new Event('change'));
                    sessionStorage.removeItem("idmenu");
                }

            });
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                  window.location.href = 'login.html'
                }else{
                    UI.hideLoader();
                    alert("Ocurrió un error al cargar la sección de etiquetas.", 'error')
                }
            })
        }
    }).catch(function(){ UI.hideLoader() });
}

function loadSelectCategories(menuId){
    let menu = objStoreInfo.menu.find(a => a.id == menuId);
    menuData = menu;

    if(menu.categories.length > 0 ){
        selectCategories.innerHTML = '<option value="0" hidden="" selected="">Selecciona una categoría</option>';
        selectProduct.innerHTML = '<option value="0" hidden="" selected="">Selecciona un producto</option>';
        selectCategories.disabled = false;

        menu.categories.forEach((category) =>{
            selectCategories.insertAdjacentHTML(
                'beforeend',
                `<option value='${category.id}'>${category.name}</option>`
            )
        });
    }
    else{
        selectCategories.disabled = true;
        selectCategories.innerHTML = '<option value="0" hidden="" selected="">Sin categorías disponibles</option>';
        selectProduct.innerHTML = '<option value="0" hidden="" selected="">Sin productos disponibles</option>';
    }
}

function loadSelectProducts(categoryId){
    let category = menuData.categories.find(element => element.id == categoryId);


    if(category.products.length > 0 ){
        selectProduct.innerHTML = '<option value="0" hidden="" selected="">Selecciona un producto</option>';
        selectProduct.disabled = false;
        category.products.forEach((product) =>{
            selectProduct.insertAdjacentHTML(
                'beforeend',
                `<option value='${product.id}'>${product.name}</option>`
            );
        });
    }
    else{
        selectProduct.innerHTML = '<option value="0" hidden="" selected="">Sin productos disponibles</option>';
    }

}

function loadSelectCategoriesCard(menuId){
    let menu = objStoreInfo.menu.find(a => a.id == menuId);
    menuData = menu;

    if(menu.categories.length > 0){
        selectCategoriesCard.disabled = false;
        selectCategoriesCard.disabled = false;
        selectCategoriesCard.innerHTML = '<option value="0" hidden="" selected="">Categoría</option>';
        selectProductCard.innerHTML = '<option value="0" hidden="" selected="" data-url="">Producto</option>';

        menu.categories.forEach((category) =>{
            selectCategoriesCard.insertAdjacentHTML(
                'beforeend',
                `<option value='${category.id}'>${category.name}</option>`
            )
        });
    }
    else{
        selectCategoriesCard.disabled = true;
        selectProductCard.disabled = true;
        selectCategoriesCard.innerHTML = '<option value="0" hidden="" selected="">Sin categorías disponibles</option>';
        selectProductCard.innerHTML = '<option value="0" hidden="" selected="">Sin productos disponibles</option>';
    }

}

function loadSelectProductsCard(categoryId){
    let category = menuData.categories.find(element => element.id == categoryId);

    if(category.products.length > 0 ){
        selectProductCard.disabled = false;
        selectProductCard.innerHTML = '<option value="0" hidden="" selected="" data-url="">Producto</option>';

        category.products.forEach((product) =>{
            selectProductCard.insertAdjacentHTML(
                'beforeend',
                `<option value='${product.id}' data-url='${product.thumbnail_image}'>${product.name}</option>`
            );
        });
    }
    else{
        selectProductCard.disabled = true;
        selectProductCard.innerHTML = '<option value="0" hidden="" selected="">Sin productos disponibles</option>';
    }
}

function clearSelectsAddProduct(){
    selectProductCard.innerHTML = '<option value="0" hidden="" selected="">Producto</option>';
    selectProductCard.disabled = true;
    btnSaveRecommendadedProduct.disabled = true;
}

function removeRecommendedProduct(e){
    UI.confirm({
        title: 'Eliminar producto recomendado',
        content: '¿Estás seguro de eliminar el producto recomendado '+ e.target.parentNode.parentNode.querySelector('.product-name').textContent +'?',
        cancel: 'No',
        accept: 'Sí'
    },function(confirm){
        if(confirm){
            let idProd = e.target.parentNode.parentNode.dataset.id,
            idCategory = e.target.parentNode.parentNode.dataset.category,
            indexTodelete = 0;

            for(let i=0; i<arrayRecommendedProducts.length; i++){
                if(arrayRecommendedProducts[i].product_id == idProd && arrayRecommendedProducts[i].category_id == idCategory){
                    indexTodelete = i;
                    break;
                }
            }

            arrayRecommendedProducts.splice(indexTodelete,1);

            e.target.parentNode.parentNode.remove();
            btnAddRecommendedProduct.classList.remove('hide');
        }
    });
}

function createLayoutProductRecommended(objetcProduct){
    let layout = `
        <div class="recommended-product-card recommended-product-card-added" data-id="${objetcProduct.id}" data-category="${objetcProduct.category_id}">
            <div class="recommended-product-card__actions">
                <span class="icon-drag"></span>
            </div>
            <div class="recommended-product-card__image">
                <div class="recommended-product-card__img" style="background: url(${objetcProduct.urlImg}); background-size: cover;
                background-position: 50% 50%;
                background-repeat: no-repeat;"></div>
            </div>
            <div class="recommended-product-card__selects recommended-product-card__info">
                <div class="menu-category">${objetcProduct.menu_name} / ${objetcProduct.category_name}</div>
                <div class="product-name">${objetcProduct.product_name}</div>
            </div>
            <div class="recommended-product-card__trash">
                <span class="icon-trash" onclick="removeRecommendedProduct(event)"></span>
            </div>
        </div>
    `;

    panelAddProduct.classList.add('hide');
    labelRecomended.textContent = 'Recomendados';
    panelListProduct.classList.remove('hide');
    panelListProduct.insertAdjacentHTML('beforeend',layout);
    arrayRecommendedProducts.push({
        product_id : objetcProduct.id,
        category_id : objetcProduct.category_id
    });
    clearSelectsAddProduct();

    if(arrayRecommendedProducts.length == 3){
        btnAddRecommendedProduct.classList.add('hide');
    }
}

function loadRecommendedProducts(){
    console.log(arrayRecommendedProducts);
    labelRecomended.textContent = "Recomendados";
    if(arrayRecommendedProducts.length != 3){
        btnAddRecommendedProduct.classList.remove('hide');
    }
    // obtener producto seleccionado
    let menu = objStoreInfo.menu.find(a => a.id == selectMenu.value),
        category = menu.categories.find(a => a.id == selectCategories.value),
        product = category.products.find(a => a.id == selectProduct.value);

    // revisar si tiene recomendados
    if(product.hasOwnProperty('recommended') && product.recommended.length != 0){
        product.recommended.forEach((product)=>{
            let categoryProd = menu.categories.find(a => a.id == product.category_id),
                productProd = categoryProd.products.find(a => a.id == product.id);
            // pintar recomendados en DOM
            createLayoutProductRecommended({
                menu_name : menu.name,
                category_id : categoryProd.id,
                category_name :  categoryProd.name,
                product_name : productProd.name,
                id : productProd.id,
                urlImg : productProd.thumbnail_image
            });
            btnUpdateProduct.disabled = false;
        });
    }
    else{
        btnUpdateProduct.disabled = true;
    }
}

function postRecommendedProducts(data){
    UI.showLoader();

    fetch( BASE_URLS.Dinny.api + '/product-recommended/set_recommended',
        {
            credentials: 'include',
            method: 'post',
            body: JSON.stringify(data)
        }
    ).then(function(response){
        if(response.ok){

            response.json().then(function(json){
                if(json.added == 3){
                    UI.hideLoader();
                    UI.message({
                        title: 'Productos recomendados',
                        content: 'Se agregaron correctamente los productos.',
                        accept: 'Aceptar'
                    }, function() {
                        location.href='recommended-products.html';
                    });
                }
                else if(json.added == 0){
                    UI.hideLoader();
                    UI.message({
                        title: 'Productos recomendados',
                        content: 'Se eliminaron los productos.',
                        accept: 'Aceptar'
                    }, function() {
                        location.href='recommended-products.html';
                    });
                }
            });

        }else{
            if(403 == response.status){
                window.location.href = 'login.html'
            }else{
                UI.message({
                    title: '',
                    content: 'Ocurrió un error al agregar productos recomendados. Por favor, inténtalo otra vez.',
                    accept: 'Aceptar'
                })
                UI.hideLoader()
            }
        }
    }).catch(function(){
        UI.hideLoader()
        UI.message({
            title: '',
            content: 'Ocurrió un error. Por favor, inténtalo nuevamente.',
            accept: 'Aceptar'
        })
    });
}

function clearLayoutProductRecommended() {
    clearSelectsAddProduct();
    panelAddProduct.classList.add('hide');
    panelListProduct.classList.add('hide');
    labelRecomended.textContent = '';
}

/************+******** EVENT LINSTENERS ***********************/

/*--------------------------------------------------------------
        SELECTS PRODUCTOS BASE
---------------------------------------------------------------*/
selectMenu.addEventListener("change" ,() => {
    loadSelectCategories(selectMenu.value);
    selectProduct.disabled = true;
    clearLayoutProductRecommended();
});

selectCategories.addEventListener("change" ,() => {
    selectProduct.disabled = true;
    loadSelectProducts(selectCategories.value);
    clearLayoutProductRecommended();
});

selectProduct.addEventListener("change", () =>{
    let cradsAdded = document.querySelectorAll('.recommended-product-card-added');

    if(cradsAdded != null){
        cradsAdded.forEach((element) =>{
            element.remove();
        });
        btnAddRecommendedProduct.classList.remove('hide');
    }

    arrayRecommendedProducts = [];
    loadRecommendedProducts();
    loadSelectCategoriesCard(selectMenu.value);
});

/*--------------------------------------------------------------
        SELECTS PRODUCTOS RECOMENDADOS
---------------------------------------------------------------*/
selectCategoriesCard.addEventListener("change" ,() => {
    loadSelectProductsCard(selectCategoriesCard.value);
    btnSaveRecommendadedProduct.disabled = true;
});

selectProductCard.addEventListener("change", () =>{
    btnSaveRecommendadedProduct.disabled = false;
});

btnCancelAddProduct.addEventListener("click", () =>{
    panelAddProduct.classList.add('hide');
    panelListProduct.classList.remove('hide');
    btnAddRecommendedProduct.classList.remove('hide');
    labelRecomended.textContent = 'Recomendados';
    clearSelectsAddProduct();
    loadSelectCategoriesCard(selectMenu.value);
});

btnSaveRecommendadedProduct.addEventListener('click', (e) =>{
    e.preventDefault();

    if(selectProduct.value == selectProductCard.value){
        UI.message({
            title: 'Productos recomendados',
            content: 'No puedes seleccionar el producto base como recomendado, por favor, selecciona otro.',
            accept: 'Aceptar'
        });
    }
    else{
        // revisar si el producto ya esta en la lista
        let findElement = (element) => element.product_id == selectProductCard.value && element.category_id == selectCategoriesCard.value ? true : false;

        if(arrayRecommendedProducts.some(findElement)){
            UI.message({
                title: 'Productos recomendados',
                content: 'Ya agregaste el producto a la lista de recomendados, por favor, selecciona otro.',
                accept: 'Aceptar'
            });
        }
        else{
            productToAdd = {
                menu_id : selectMenu.value,
                menu_name: selectMenu.selectedOptions[0].textContent,
                category_id : selectCategoriesCard.value,
                category_name: selectCategoriesCard.selectedOptions[0].textContent,
                id : selectProductCard.value,
                product_name: selectProductCard.selectedOptions[0].textContent,
                urlImg : selectProductCard.selectedOptions[0].dataset.url
            }
            createLayoutProductRecommended(productToAdd);
            btnUpdateProduct.disabled = false;
            loadSelectCategoriesCard(selectMenu.value);
            if(arrayRecommendedProducts.length == 3){
                btnAddRecommendedProduct.classList.add('hide');
            }
            else{
                btnAddRecommendedProduct.classList.remove('hide');
            }
        }
    }

});

btnAddRecommendedProduct.addEventListener('click', () =>{
    panelListProduct.classList.add('hide');
    panelAddProduct.classList.remove('hide');
    btnAddRecommendedProduct.classList.add('hide');
    labelRecomended.textContent = 'Agregar producto recomendado';
    if(selectMenu.length == 1){
        objStoreInfo.menu.forEach((element) => {
            selectMenuCard.insertAdjacentHTML(
                'beforeend',
                `<option value='${element.id}'>${element.name}</option>`
            );
        });
    }
    else{
        return
    }
});

btnUpdateProduct.addEventListener("click", (e) => {
    e.preventDefault();
    if(arrayRecommendedProducts.length != 3 && arrayRecommendedProducts.length != 0){
        UI.message({
            title: 'Productos recomendados',
            content: 'Selecciona tres productos para que aparezcan como recomendados.',
            accept: 'Aceptar'
        });
    }
    else{
        function returnOrder(){
            let orderList = document.querySelectorAll('.recommended-product-card-added'),
                arrayOrder = [];

            if(orderList.length != 0){
                for(let i=0; i<3; i++){
                    arrayOrder.push(
                        {
                            product_id : orderList[i].dataset.id,
                            category_id : orderList[i].dataset.category,
                        }
                    );
                }
            }
            return arrayOrder;
        }

        let objectToSend = {
            store_id : id_current_store,
            menu_id : selectMenu.value,
            category_id : selectCategories.value,
            product_id : selectProduct.value,
            recommended : returnOrder()
        }

        postRecommendedProducts(objectToSend);
    }

});